class Messages {
    constructor(propertyHash, userAgent, referer, ip, url, name, email, phone, message) {
        this.propertyHash = propertyHash
        this.userAgent = userAgent
        this.referer = referer
        this.ip = ip
        this.url = url
        this.name = name
        this.email = email
        this.phone = phone
        this.message = message
    }
}

export default Messages
